import { SelectControlValueAccessor } from '@angular/forms';
import { CustomElementJoins } from './apiclient/model/customElementJoins';
import { Injectable } from '@angular/core';
import { CustomEntityService } from './apiclient/api/customEntity.service';
import { CustomEntityFull } from './apiclient/model/customEntityFull';
import { UserSessionService } from './UserSession/user-session.service';
import { Console } from 'console';

/**
 * Servicio que implementa métodos de utilería de las Entidades personalizadas
 */
@Injectable({
  providedIn: 'root'
})
export class CustomEntityUtils {


  private entities: any;
  private companyEntities;
  private ineditionEntity;
  private ineditionCompany;
  private attributeList;

  constructor(
    private userSessionService: UserSessionService,
    private entityService: CustomEntityService) { }


    /**
     * Activa la edición de una determinada entidad
     * @param idEntity Identificador de la entidad
     */
  public editingEntity(idCompany,idEntity){
    this.ineditionCompany = idCompany;
    this.ineditionEntity = idEntity;
    this.entities = null;
    this.getEntities();
  }

  /**
   * Obtiene listado de entidades
   * @returns
   */
  getEntities(){
    if(null == this.entities){
      this.userSessionService.getCachedCustomEntitiesFullList(undefined).subscribe((data) => {
        if(this.ineditionEntity != 0){
          let joins:any = data.filter(element => element.id == this.ineditionEntity)[0].joins;
          if(joins != null && joins.length > 0){
            this.entities =  data.filter(element => joins.indexOf(element.id) >= 0);
          }else{
            this.entities = data.filter(e => e.id != this.ineditionEntity);
          }

        }else{
          this.entities = data.filter(e => e.id != this.ineditionEntity);
        }

        this.companyEntities = data.filter(e => e.company_id == this.ineditionCompany && e.id != this.ineditionEntity);
      });
    }
    return this.entities;
  }

  public listValuesElement(entity, idAttribute){
    let listaValores = [];
      // Para cada elemento de la entidad
      for (let i = 0; i < entity.elements.length; i++){
        for (let j = 0; j < entity.attributes.length; j++){
          // Busco el atributo pasado como parámetro, que será de tipo 'text'
          if (entity.elements[i].attributes[j] != undefined){
            if (idAttribute == entity.elements[i].attributes[j].id && entity.elements[i].workingfrom == undefined && entity.elements[i].workinguntil == undefined){
            // Se añade el valor del atributo a la lista
            listaValores.push(entity.elements[i].attributes[j].value);
            }
        }
      }
    }
    return listaValores;
  }

 getCompanyEntities(): any[] {
  return this.companyEntities;
  }

  getInEditionCompany(){
    return this.ineditionCompany;
  }


  /**
   * Devuelve el nombre de una determinada entidad
   * @param entityid Identificador de entidad
   * @returns
   */
   getEntityName(entityid){
      return this.entities.filter(entity => entity.id === entityid)[0].name;
    }

    /**
     * DEvuelve las relaciones de una entidad
     * @param elementid  Identificador de entidad
     * @returns
     */
    public async getElementJoins(elementid: number){
      console.log(elementid)
      try{


      var joins = await this.entityService.getcustomelementjoins(''+elementid,this.ineditionCompany,this.userSessionService.accessToken).toPromise()

      var sourceEntity = await this.getCurrentEntity();
      var sourceElement = sourceEntity.elements.find(e => e.id == elementid);

      joins.simple = joins.simple.concat(this.calculateAttributeJoins(sourceEntity,sourceElement))

      return joins;
    }catch(e){
      console.log(e)
    }


    }

    public calculateAttributeJoins(sourceEntity: any,element: any){


      var joins = []
      if(null != sourceEntity.attributejoins && undefined != sourceEntity.attributejoins){
        for(let attributejoin of sourceEntity.attributejoins){
          var attributeSource = element.attributes.find( a => a.id == attributejoin.attributeSource);
          if(attributeSource != undefined){
            var valorSource = attributeSource.value;

            var targetEntity = this.companyEntities.find(e => e.id == attributejoin.entity)

            for(let elementoTarget of targetEntity.elements){
              var atributoTarget = elementoTarget.attributes.find( a => a.id == attributejoin.attributeTarget);
              if(atributoTarget != undefined && atributoTarget.value == valorSource){
                joins.push({entityId:targetEntity.id,entityName:targetEntity.name,id:elementoTarget.id,name:elementoTarget.name,byAttribute:true})
              }
            }
          }

      }
      }


      return joins;
    }

    /**
     * DEvuelve la entidad actual en edición
     * @returns
     */
    public async getCurrentEntity(): Promise<any>{
      return new Promise((resolve,reject) => {
        this.userSessionService.getCachedCustomEntitiesFullList(undefined).subscribe((data) => {
            resolve(data.filter(entity => entity.id == this.ineditionEntity)[0])
        })
      })

    }



    /**
     * Devuelve un determinado elemento
     * @param elementid Identificador de elemento
     * @returns
     */
    public async getElement(elementid: number){
      return (await this.getCurrentEntity()).elements.filter(element => element.id == elementid)[0];
    }


    public getAttributeList(){
      return this.attributeList;
    }

    public setAttributeList(attributes){
      this.attributeList = attributes;
    }

}
